<sergeant-title (showMoreClicked)="onShowMoreSpecialConstraints()" [title]="'Spesielle forhold'"></sergeant-title>
<div class="listing">
    {{ constraintsText() }}
</div>
